import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'search-form',
  templateUrl: './search-form.component.html'
})

export class SearchFormComponent implements OnInit{
	keywords;
	constructor(private router: Router, private activatedRoute: ActivatedRoute) {}
	ngOnInit() {
		this.activatedRoute.queryParams.subscribe(params => {
			this.keywords = params.keywords ? params.keywords : '';
		});
 	}
	onSubmit(form) {
		if(form.value.keywords !='') this.router.navigateByUrl('/?keywords='+form.value.keywords);
	}
}